// extracted by mini-css-extract-plugin
module.exports = {"loader":"SettingsModal_loader__C5N9g"};